import request from "@/utils/request";

// 查询学科列表
export const  checkJyeooToken =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainToken",
        method:"get",
        params: query
    })
}

// 查询学科列表
export const  listSubject =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainSubject",
        method:"get",
        params: query
    })
}

// 查询全部学科列表
export const  listAllSubject =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainAllSubject",
        method:"get",
        params: query
    })
}

// 查询教材版本列表
export const  listEdition =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainEdition",
        method:"get",
        params: query
    })
}

// 查询教材版本年级列表
export const  listGrade =(data) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainGrade",
        method:"post",
        data: data
    })
}

// 查询教材列表
export const  listBook =(data) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainBookList",
        method:"post",
        data: data
    })
}

// 查询教材章节列表
export const  listCategory =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainBookCategory",
        method:"get",
        params: query
    })
}

// 查询教材章节列表
export const  listQuesType =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainQueType",
        method:"get",
        params: query
    })
}

// 查询试题来源列表
export const  listQuesSource =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainQueSource",
        method:"get",
        params: query
    })
}

// 查询试题能力列表
export const  listQuesAbility =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainAbility",
        method:"get",
        params: query
    })
}

// 查询试题列表
export const  listQuestion =(data) =>{
    return request({
        url: "/businessservice/jyeoo/ques/gainQuesCondition",
        method:"post",
        data: data
    })
}

// 查询考点（知识点）列表
export const  listPoint =(query) =>{
    return request({
        url: "/businessservice/jyeoo/base/gainPoint",
        method:"get",
        params: query
    })
}


// 试题加入试题篮
export const  quesAddBasket =(data) =>{
    return request({
        url: "/businessservice/jyeoo/basket/quesAddBasket",
        method:"post",
        data: data
    })
}

// 试题篮删除试题
export const  quesDelBasket =(data) =>{
    return request({
        url: "/businessservice/jyeoo/basket/quesDelBasket",
        method:"post",
        data: data
    })
}

// 查询试题篮
export const  queryBasket =(query) =>{
    return request({
        url: "/businessservice/jyeoo/basket/gainBasket",
        method:"get",
        params: query
    })
}

// 清空试题篮
export const  clearBasket =(query) =>{
    return request({
        url: "/businessservice/jyeoo/basket/clearBasket",
        method:"get",
        params: query
    })
}

// 试题篮删除试题(按类型)
export const  delQuesByCate =(data) =>{
    return request({
        url: "/businessservice/jyeoo/basket/delQuesByCate",
        method:"post",
        data: data
    })
}

// 生成组卷
export const  generatePaper =(data) =>{
    return request({
        url: "/businessservice/jyeoo/paper/generatePaper",
        method:"post",
        data: data
    })
}

// 查询试题篮
export const  downPaper =(query) =>{
    return request({
        url: "/businessservice/jyeoo/paper/downPaper",
        method:"get",
        params: query
    })
}

// 查询组卷列表
export const  listPaper =(query) =>{
    return request({
        url: "/businessservice/jyeoo/paper/paperList",
        method:"get",
        params: query
    })
}

// 下载组卷
export const  downloadPaper =(data) =>{
    return request({
        url: "/businessservice/jyeoo/paper/downPaper",
        method:"post",
        data: data
    })
}

// 查询用户组卷学段
export const  userPaperPeriod =(query) =>{
    return request({
        url: "/businessservice/user/userPaperPeriod",
        method:"get",
        params: query
    })
}

// 查询用户组卷学科
export const  userPaperSubject =(query) =>{
    return request({
        url: "/businessservice/user/userPaperSubject",
        method:"get",
        params: query
    })
}